import LoanProductPage from '@/pages/loan/components/LoanProductPage';

export default function DailyPage() {
  return <LoanProductPage slug="daily" />;
}